/**
 * Type guards for narrowing untyped JSON (API payloads, stored files,
 * exported traces) before reading its fields.
 */

/** A plain object: not null and not an array. */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}
